(function () {
  'use strict';

  function isMobile() { 
    return window.innerWidth < 750; 
  }

  function isSingle($slider) {
    return $slider.find('.slick-slide:not(.slick-cloned)').length <= 1;
  }

  function updatePaddingForSlide($slider, currentSlide) {
    var $list = $slider.find('.slick-list');
    var total = $slider.find('.slick-slide:not(.slick-cloned)').length;
    var current = typeof currentSlide !== 'undefined' ? currentSlide : $slider.slick('slickCurrentSlide');
    var isLast = (current >= total - 1);

    if (isLast) {
      // Son resimde sağ boşluğu sıfırla, sola aktar
      $list.attr('style', 'overflow: visible !important; padding-right: 0px !important; padding-left: 45px !important;');
    } else {
      // Diğer resimlerde normal peek düzeni
      $list.attr('style', 'overflow: visible !important; padding-right: 45px !important; padding-left: 0px !important;');
    }
  }

  function initPeekSlider() {
    var $mainSlider = $('.productView-images-wrapper .slick-initialized').first();
    if (!$mainSlider.length) return;
    if (!isMobile()) return;
    if (isSingle($mainSlider)) return; // Tek resim varsa efekti çalıştırma

    $mainSlider.slick('unslick');

    $mainSlider.slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 350,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      swipe: true,
      touchThreshold: 10,
      cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      fade: false,
      centerMode: false,
      variableWidth: false
    });

    // İlk açılışta kontrol et
    updatePaddingForSlide($mainSlider);

    // Her slide değişiminden sonra çalıştır
    $mainSlider.on('afterChange', function (e, slick, current) {
      updatePaddingForSlide($(this), current);
    });
  }

  function run() { 
    setTimeout(initPeekSlider, 600); 
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () { 
    setTimeout(initPeekSlider, 900); 
  });
})();